<template>
  <div class="navbar_wrap hidden-xs-only">
    <div class="navbar_container">
      <div class="navbar_left" @click="$router.push('/home')">
        <img :src="globalDicts.logo_color" alt="logo" />
      </div>
      <div class="navbar_right">
        <el-menu :default-active="activeIndex" class="el_menu_demo" mode="horizontal" background-color="#fff"
          text-color="#333" active-text-color="#000" @select="changeCurrentPage">
          <template v-for="(item, index) in menuList" >
            <el-menu-item v-if="!item.children || item.children.length === 0" :index="String(item.id)">
              {{ item.menuName }}
            </el-menu-item>
            <el-submenu v-else :index="String(item.id)">
              <template slot="title">{{ item.menuName }}</template>
              <el-menu-item v-for="(child, childIndex) in item.children" :key="child.id" :index="String(child.id)">
                {{ child.menuName }}
              </el-menu-item>
            </el-submenu>
          </template>
          <el-menu-item index="100" class="menu_item" @click="$router.push('/demo')"><a href="#">立即体验</a></el-menu-item>
        </el-menu>
        <!-- <a href="#">立即体验</a> -->
        <span class="right_phone">
          <i class="el-icon-phone"></i>
          <span> {{ globalDicts.contact }} </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      activeIndex: '1',
    }
  },
  computed: {
    ...mapGetters(['getMenuList']),
    menuList() {
      return this.getMenuList
    },
    globalDicts() {
      return this.$store.getters.getDicts;
    },
  },
  props: {
    selectIndex: {
      type: Number,
      default: 0,
    },
  },
  mounted() {
    this.fetchMenuList().then(() => {
      for (let menu of this.menuList) {
        let ok = false
        if (menu.children) {
          for (let child of menu.children) {
            if (child.routePath === this.$route.path) {
              this.activeIndex = child.id + ''
              ok = true
              break
            }
          }
        }
        if (ok) {
          break
        }
      }
    })
  },
  methods: {
    ...mapActions(['fetchMenuList']),
    changeCurrentPage(index) {
      // 根据menuList查找对应的路由路径
      let routePath = ''
      const findRoute = (menus, targetId) => {
        for (const menu of menus) {
          if (String(menu.id) === targetId) {
            return menu.routePath
          }
          if (menu.children && menu.children.length > 0) {
            const childRoute = findRoute(menu.children, targetId)
            if (childRoute) {
              return childRoute
            }
          }
        }
        return ''
      }
      routePath = findRoute(this.menuList, index)

      if (routePath) {
        this.$router.push(routePath).catch((v) => { })
      } else if (index === '100') { // Hardcoded index for "立即体验"
        this.$router.push('/demo').catch((v) => { })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.navbar_wrap {
  width: 100%;
  height: 70px;
  background: #fff;
  backdrop-filter: saturate(180%) blur(0.5rem);
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  box-shadow: 0 5px 30px rgba($color: #000000, $alpha: .05);

  .navbar_container {
    width: 70%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .navbar_left {
      display: flex;
      align-items: center;
      height: 100%;

      img {
        width: 160px;
        cursor: pointer;
      }
    }

    .navbar_right {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 20px;

      a {
        text-decoration: none;
        color: #0038a4;
        display: inline-block;
        width: 100px;
        background: #ffa400;
        line-height: 27px;
        text-align: center;
        border-radius: 20px;
        padding: 5px;
      }

      .el_menu_demo {
        border: none;
      }

      .menu_item {
        &:hover {
          font-weight: 600;
          background: transparent !important;
        }
      }

      .right_phone {
        &:hover {
          color: #ccc;
        }

        transition: all 0.5s;
        display: flex;
        align-items: center;

        i {
          font-size: 20px;
        }

        span {
          margin-left: 0.5rem;
        }

        margin-left: 2.5rem;
        color: #000;
      }
    }
  }
}
</style>